import { render } from "./NavigationButton.vue?vue&type=template&id=a9189a68&scoped=true&ts=true"
import script from "./NavigationButton.vue?vue&type=script&lang=ts"
export * from "./NavigationButton.vue?vue&type=script&lang=ts"

import "./NavigationButton.vue?vue&type=style&index=0&id=a9189a68&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9189a68"]])

export default __exports__